<template>
  <zone-table
    :value="zoneNameSearch"
    :zones="inCountryZones"
    :active-zone="activeInCountryZone"
    @input="onSearchInput"
    @on-row-click="$emit('on-row-click', $event)"
    @on-remove-click="onDeleteClick"
    @on-edit-click="onEditButtonClick"
  ></zone-table>
</template>
<script>
import debounce from 'lodash-es/debounce'
import Swal from 'sweetalert2'
import { mapGetters, mapActions, mapState } from 'vuex'
import ZoneTable from './zone-table'
import EventBus from '../event-bus'
import Mixins from '../mixins'

export default {
  name: 'ZoneInCountryAreas',
  components: { ZoneTable },
  mixins: [Mixins],
  computed: {
    ...mapGetters('zones', [
      'inCountryZones',
      'activeCountryZone',
      'activeInCountryZone',
    ]),
    ...mapState('zones', ['zoneNameSearch']),
  },

  methods: {
    ...mapActions('zones', [
      'removeInCountryZone',
      'updateInCountryZones',
      'fetchInCountryZones',
    ]),

    onSearchInput(value) {
      this.$store.commit('zones/setZoneNameSearch', value)
      this.debouncedFetchInCountryZones()
    },

    debouncedFetchInCountryZones: debounce(function() {
      if (this.activeCountryZone?.id) {
        this.fetchInCountryZones(this.activeCountryZone.id)
      }
    }, 300),

    async onDeleteClick(inCountryZone) {
      const { value: yes } = await Swal({
        title: this.$t('zones.delete_confirmation'),
        type: 'question',
        showCancelButton: true,
      })

      if (yes) {
        this.removeInCountryZone(inCountryZone)
          .then(() => EventBus.$emit('on-zone-removed', inCountryZone))
          .catch(err => this.$toast.error(err.data.message))
      }
    },
    async onEditButtonClick(countryZoneToUpdate) {
      const { value: title } = await this.prompt(
        this.$t('new_title_for_zone'),
        countryZoneToUpdate.title,
      )

      if (title) {
        countryZoneToUpdate.title = title
        this.updateInCountryZones({
          ...countryZoneToUpdate,
          division_id: this.activeCountryZone.id,
        }).catch(err => this.$toast.error(err.data.message))
      }
    },
  },
}
</script>
